import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import type { LocalDashboardAction } from '../utils/dashboardLocalActions';

interface QuickActionsBarProps {
  actions: LocalDashboardAction[];
  /** Wrapper spacing/placement classes. */
  className?: string;
}

export const QuickActionsBar: React.FC<QuickActionsBarProps> = ({
  actions,
  className = '',
}) => {
  const navigate = useNavigate();
  if (!actions.length) return null;

  return (
    <div className={`d-flex flex-wrap gap-2 ${className}`.trim()}>
      {actions.map((action) => (
        <Button
          key={action.key}
          variant="outline-primary"
          size="sm"
          onClick={() => navigate(action.path)}
        >
          {action.label}
        </Button>
      ))}
    </div>
  );
};
